import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';

@Component({
  selector: 'app-block-user-dialog',
  standalone: true,
  imports: [],
  templateUrl: './block-user-dialog.component.html',
  styleUrl: './block-user-dialog.component.scss'
})
export class BlockUserDialogComponent {
  // create reference to dialog and pass the data type to pass to parent component when dialog is closed (boolean) to trigger save or cancel
  dialogRef = inject<DialogRef<boolean>>(DialogRef<boolean>);
  data = inject(DIALOG_DATA);
}
